import { Currency } from 'src/app/shared/models/currency.model';

export class Wallet {
  currency!: Currency;
  balance!: number;
  blockedBalance!: number;

  constructor(input: any = {}) {
    this.currency = new Currency(input.currency);
    this.blockedBalance = input.blocked_balance;
    this.balance = this.currency?.id === 'IRR' ? Math.round(input.balance / 10) : input.balance;
    this.blockedBalance =
      this.currency?.id === 'IRR' ? Math.round(input.blocked_balance / 10) : input.blocked_balance;
  }
}

export interface AssetValue {
  wallet: Wallet;
  IRTPrice: number;
  USDTPrice: number;
}
